import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table table-hover align-middle" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Название"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"10%"}
    }, "Количество"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Цена"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Итого"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" })
  ])
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  colspan: "5",
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Корзина пуста, ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("выберите пельмешки в каталоге")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartTableRow = _resolveComponent("CartTableRow")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.cartAsArray, (cartItem, idx) => {
        return (_openBlock(), _createBlock(_component_CartTableRow, {
          key: idx,
          cartItem: cartItem
        }, null, 8, ["cartItem"]))
      }), 128)),
      (!_ctx.$store.getters.cartAsArray.length)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
            _createElementVNode("td", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_router_link, { to: "/catalog" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}